<template>
  <div id="app"
       :class="{showingMenu: showingMenu}"
       @click="hideMenu">
    <div class="header text-white">
      <div class="d-flex justify-content-end top text-center no-gutters">
        <div class="col-lg-2 d-flex flags align-items-center justify-content-end">
          <a class="mr-2"
             :class="{selected: language === 'english'}"
             href="javascript:void(0)"
             @click="setLanguage('english')"
             title="Set language to English">
            <img src="static/usflag.png" alt="">
          </a>

          <a href="javascript:void(0)"
             :class="{selected: language === 'spanish'}"
             @click="setLanguage('spanish')"
             title="Selecciona para ver el contenido en español">
            <img src="static/spainflag.png" alt="">
          </a>
        </div>

        <div class="d-none col-2 d-lg-block">
          <a class="btn btn-block call"
             :title="lang.call"
             href="tel:770-402-1653">
            <span class="d-block">{{ lang.call }}</span>

            <span class="d-block">
              <i class="fas fa-phone-alt mr-2"></i> 770-402-1653
            </span>
          </a>
        </div>

        <div class="d-lg-none col-2 px-4 d-flex justify-content-end align-items-center">
          <a href="javascript:void(0)"
             title="Mobile menu"
             @click.stop="showMenu"
             class="menu"
             :class="{ selected: showingMenu }"><i class="fas fa-bars"></i></a>
        </div>
      </div>

      <div class="d-none d-lg-flex bottom text-right justify-content-end">
        <div class="w-75 d-flex justify-content-around">
          <a href="javascript:void(0)"
             title="Go to Home"
             @click="setPage('home')"
             :class="{selected: page === 'home'}">{{ eng ? 'Home' : 'Inicio' }}</a>

          <a href="javascript:void(0)"
             title="Go to our services"
             @click="setPage('services')"
             :class="{selected: page === 'services'}">{{ eng ? 'Services' : 'Servicios' }}</a>

          <a href="javascript:void(0)"
             title="Go to the gallery"
             @click="setPage('gallery')"
             :class="{selected: page === 'gallery'}">{{ eng ? 'Gallery' : 'Galería' }}</a>

          <a href="javascript:void(0)"
             title="Apply Now"
             @click="setPage('careers')"
             :class="{selected: page === 'careers'}">{{ eng ? 'Join Our Team' : 'Empleos' }}</a>

          <a href="javascript:void(0)"
             title="Go to contact"
             @click="setPage('contact')"
             :class="{selected: page === 'contact'}">{{ eng ? 'Contact Us' : 'Contáctanos' }}</a>
        </div>
      </div>

      <img src="static/logo.jpg" alt="" class="logo">
    </div>

    <div id="page">
      <Home v-if="page === 'home'" :eng="eng"></Home>
      <Services v-else-if="page === 'services'" :eng="eng"></Services>
      <Gallery v-else-if="page === 'gallery'" :eng="eng"></Gallery>
      <Careers v-else-if="page === 'careers'" :eng="eng"></Careers>
      <Contact v-else-if="page === 'contact'" :eng="eng"></Contact>
    </div>

    <div class="footer d-flex justify-content-center">
      <div class="container">
        <h1 class="text-center mb-4">{{ lang.contact }}</h1>

        <div>
          <label>{{ lang.name }}</label>
          <input class="form-control mb-3"
                 type="text"
                 v-model="name"
                 :placeholder="lang.name">

          <label>{{ lang.phone }}</label>
          <input class="form-control mb-3"
                 type="text"
                 v-model="phone"
                 :placeholder="lang.phone">

          <label>{{ lang.email }}</label>
          <input class="form-control mb-3"
                 type="email"
                 v-model="email"
                 :class="{'is-invalid': submitted && !email}"
                 :placeholder="lang.email">

          <label>{{ lang.company }}</label>
          <input class="form-control mb-3"
                 type="text"
                 v-model="company"
                 :placeholder="lang.company">

          <label>{{ lang.message }}</label>
          <textarea class="form-control mb-4"
                    v-model="message"
                    :class="{'is-invalid': submitted && !message}"
                    :placeholder="lang.message"></textarea>
        </div>

        <button class="btn bg-dark-blue text-white btn-block"
                @click="submitForm">{{ eng ? 'Submit' : 'Enviar' }}</button>

        <div class="d-md-flex no-gutters signature">
          <div class="col-md-6">
            <h5 class="mb-1">Antonio Cruz</h5>

            <p class="mb-0">
              <a href="mailto:antonio@acttelecom.com" title="Send an email">
                <i class="far fa-envelope mr-1"></i>
                <span>antonio@acttelecom</span>
              </a>
            </p>

            <a href="tel:770-402-1653" title="Call us now at 770-402-1653">
              <i class="fas fa-phone-alt mr-1"></i>
              <span>770-402-1653</span>
            </a>
          </div>

          <div class="col-md-6 copyright">
            &copy; 2019 by ACTtelecom
          </div>
        </div>
      </div>
    </div>

    <div class="lightbox" v-show="showingMenu">
      <ul class="menu">
        <li>
          <a href="tel:770-402-1653"
             :title="lang.call"><strong>{{ lang.call }}</strong> <i class="fas fa-phone-alt mr-1"></i></a>
        </li>

        <li class="separator"></li>

        <li>
          <a href="javascript:void(0)"
             title="Go to Home"
             @click="setPage('home')"
             :class="{selected: page === 'home'}">{{ eng ? 'Home' : 'Inicio' }} <i class="fas fa-home"></i></a>
        </li>

        <li>
          <a href="javascript:void(0)"
             title="Go to our services"
             @click="setPage('services')"
             :class="{selected: page === 'services'}">{{ eng ? 'Services' : 'Servicios' }} <i class="fas fa-toolbox"></i></a>
        </li>

        <li>
          <a href="javascript:void(0)"
             title="Go to the gallery"
             @click="setPage('gallery')"
             :class="{selected: page === 'gallery'}">{{ eng ? 'Gallery' : 'Galería' }} <i class="far fa-images"></i></a>
        </li>

        <li>
          <a href="javascript:void(0)"
             title="Apply Now"
             @click="setPage('careers')"
             :class="{selected: page === 'careers'}">{{ eng ? 'Join Our Team' : 'Empleos' }} <i class="fas fa-users"></i></a>
        </li>

        <li>
          <a href="javascript:void(0)"
             title="Go to contact"
             @click="setPage('contact')"
             :class="{selected: page === 'contact'}">{{ eng ? 'Contact Us' : 'Contáctanos' }} <i class="fas fa-envelope-open-text"></i></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import text from './components/language.json'

  import Careers from './components/Careers.vue'
  import Contact from './components/Contact.vue'
  import Gallery from './components/Gallery.vue'
  import Home from './components/Home.vue'
  import Services from './components/Services.vue'

  export default {
    components: {
      Careers,
      Contact,
      Gallery,
      Home,
      Services
    },

    computed: {
      eng () {
        return this.language === 'english'
      },

      lang () {
        return this.eng ? this.text.en : this.text.sp
      }
    },

    data () {
      return {
        company: '',
        email: '',
        language: 'english',
        message: '',
        name: '',
        page: 'home',
        phone: '',
        showingMenu: false,
        submitted: false,
        text
      }
    },

    methods: {
      hideMenu () {
        this.showingMenu = false
      },

      setLanguage (lang) {
        if (this.language === lang) return

        this.language = lang
        localStorage.language = lang
      },

      setPage (page) {
        this.page = page
        localStorage.page = page
      },

      showMenu () {
        this.showingMenu = !this.showingMenu
      },

      submitForm () {
        this.submitted = true
        if (!this.email || !this.message) return this.$swal.fire({ type: 'error', text: 'Please provide your email and type a message. All other fields are optional.'})

        let data = {
          company: this.company,
          email: this.email,
          message: this.message,
          name: this.name,
          phone: this.phone
        }

        this.$http.post('inc/email.php', qs.stringify(data)).then(res => {
          this.$swal.fire({ type: 'success', text: 'Email has been sent. Thank you for contacting us.'})

          this.submitted = false
          this.company = ''
          this.email = ''
          this.message = ''
          this.name = ''
          this.phone = ''
        }).catch(err => {
          console.log('error: ', err)
          this.$swal.fire({ type: 'error', text: 'Email could not be sent. Please try again in five minutes.'})
        })
      }
    },

    mounted () {
      let page = localStorage.page
      if (page) this.setPage(page)

      let lang = localStorage.language
      if (lang) this.setLanguage(lang)

      setTimeout(() => {
        console.log('the language', this.language)
      }, 5000)
    }
  }
</script>

<style lang="sass" scoped>
  @import '../static/global.sass'

  #app
    min-height: 100vh
    background-color: rgba(255, 255, 255, 0.9)
    user-select: none

    &.showingMenu
      height: 100vh
      overflow: hidden

  .copyright
    text-align: right

  .flags
    a
      display: block
      &.selected
        img
          transform: scale(1)
          opacity: 1

      img
        width: 50px
        height: 32px
        transform: scale(0.8)
        opacity: 0.8
        transition: 140ms linear all
        &:hover
          opacity: 1

  .footer
    background-color: white
    padding: 50px 0
    box-shadow: 0 0 20px #b0b0b0

    label
      margin-bottom: 0
      font-size: 14px
      color: #777

    .signature
      margin-top: 50px

  .header
    position: fixed
    width: 100%
    top: 0
    left: 0
    z-index: 9

    .bottom
      background-color: $dark-blue

      a
        font-weight: bold
        color: white
        text-decoration: none
        padding: 15px 30px
        font-size: 18px
        transition: 140ms linear all

        &:hover,
        &.selected
          background-color: white
          color: $dark-blue

    .call
      color: white
      border-radius: 0
      transition: 140ms linear all
      &:hover
        background-color: white
        color: $main-blue

    .hands
      font-size: 28px

    .logo
      position: absolute
      top: 5px
      left: 50px
      box-shadow: 0 0 10px black

    .menu
      font-size: 30px
      text-decoration: none
      color: white
      padding: 0 10px
      &.selected
        color: $dark-blue
        background-color: white

    .top
      background-color: $main-blue
      min-height: 60px

      button
        font-weight: bold

  .lightbox
    background-color: rgba(0, 0, 0, 0.3)
    position: fixed
    top: 0
    left: 0
    width: 100vw
    height: 100vh
    z-index: 8

    .menu
      list-style: none
      background-color: white
      position: absolute
      right: 23px
      top: 60px
      padding: 5px 0
      width: 220px

      a
        display: block
        padding: 10px 15px
        border-bottom: 1px solid #EEE
        position: relative
        color: #0056b3

        i
          position: absolute
          right: 15px
          top: 12px

  #page
    padding-top: 119px

  @media screen AND (max-width: 1024px)
    .header
      .bottom a
        font-size: 16px

      .logo
        left: 20px

  @media screen AND (max-width: 768px)
    .flags
      a img
        width: 40px
        height: 26px

    .header
      .logo
        top: 3px
        left: 13px
        width: 130px

    #page
      padding-top: 50px

  @media screen AND (max-width: 414px)
    .flags
      a:last-child
        margin-right: 20px

    .footer
      .signature > div
        text-align: center

    .header
      .logo
        top: 2px
        left: 3px
        width: 105px
</style>

<style lang="sass">
  @import '../static/global.sass'
  @import url('../node_modules/bootstrap/dist/css/bootstrap.css')
  @import url('../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css')
  @import url('../node_modules/@fortawesome/fontawesome-free/css/all.css')

  body
    background-color: $light-blue
    background-image: url("/static/tower.jpg")
    background-attachment: fixed
    background-size: cover

  img
    max-width: 100%

  .main-blue
    color: $main-blue

  .bg-dark-blue
    background: $dark-blue

  .bg-main-blue
    background: $main-blue

  .mb-80
    margin-bottom: 80px !important

  textarea
    resize: none
    min-height: 100px
</style>



// WEBPACK FOOTER //
// src/App.vue